import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _possibleConstructorReturn from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _inherits from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import BaseModel from "./BaseModel";
import moment from 'moment';
var Card = /*#__PURE__*/function (_BaseModel) {
  function Card(params) {
    var _this;
    _classCallCheck(this, Card);
    _this = _callSuper(this, Card, [params]);
    _this._types = {
      1: 'Visa Debit',
      3: 'Visa Electron',
      5: 'Switch / Maestro',
      6: 'Mastercard'
    };
    _this._typesIcons = {
      1: 'cp_visa',
      3: 'cp_visa_electron',
      5: 'cp_switch',
      6: 'cp_mastercard'
    };
    return _this;
  }
  _inherits(Card, _BaseModel);
  return _createClass(Card, [{
    key: "type",
    value: function type() {
      return this._types[this.get('card_type_id')];
    }
  }, {
    key: "typeIcon",
    value: function typeIcon() {
      return this._typesIcons[this.get('card_type_id')];
    }
  }, {
    key: "isDefault",
    value: function isDefault() {
      return this.get('is_default');
    }
  }, {
    key: "lastDigits",
    value: function lastDigits() {
      return this.get('last_four');
    }
  }, {
    key: "setDefault",
    value: function setDefault(val) {
      this.params.is_default = val;
      return this;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return moment(this.get('expiry')).endOf('month') > moment().startOf('month');
    }
  }, {
    key: "expiry",
    value: function expiry() {
      return moment(this.get('expiry')).format('MM/YY');
    }
  }, {
    key: "setParams",
    value: function setParams(params) {
      if (this.id() === params.id) {
        this.params = params;
      }
      return this;
    }
  }]);
}(BaseModel);
export default Card;